module.exports = __webpack_public_path__ + "img/img3.a2207b36.jpg";